import { INSURANCE_COMPARE_CATEGORY_LIST } from '@common/constants';
import React from 'react';

const InputInsuranceCategoryTable = ({
  id = $utils.getRandomId(),
  value,
  isInput,
  isReadonly,
  onChange,
}) => {
  const makeValue = (label, option) => `${label}(${option})`;

  const handleChange = (label, option) => {
    if (typeof onChange === 'function') {
      onChange(makeValue(label, option));
    }
  };

  return (
    <table className="insurance-category tbl-sty5">
      <colgroup>
        <col style={{ width: '20%' }} />
        <col style={{ width: 'auto' }} />
      </colgroup>

      <thead>
        <tr>
          <th scope="col">보험목적(유사보험군)</th>
          <th scope="col">보험종류</th>
        </tr>
      </thead>

      <tbody>
        {isInput ? (
          <>
            {INSURANCE_COMPARE_CATEGORY_LIST.map(
              ({ label, options }, index) => (
                <tr key={index}>
                  <th>{label}</th>

                  <td>
                    <div className="check-box mg-0">
                      {options.map((option, optionIndex) => (
                        <div
                          key={`radio-${id}-${index}-${optionIndex}`}
                          className="check-wrap small"
                        >
                          <input
                            id={`radio-${id}-${index}-${optionIndex}`}
                            type="radio"
                            name={`${id}-insuranceKind`}
                            checked={
                              isReadonly
                                ? false
                                : makeValue(label, option) === value
                            }
                            onChange={() => handleChange(label, option)}
                          />
                          <label
                            htmlFor={`radio-${id}-${index}-${optionIndex}`}
                          >
                            {option}
                          </label>
                        </div>
                      ))}
                    </div>
                  </td>
                </tr>
              ),
            )}
          </>
        ) : (
          <>
            {INSURANCE_COMPARE_CATEGORY_LIST.map(
              ({ label, options }, index) => (
                <tr key={index}>
                  <th>{label}</th>

                  <td>
                    <div className="insurance-category-options">
                      {options.map((option, optionIndex) => (
                        <div
                          key={optionIndex}
                          className="insurance-category-option"
                        >
                          {option}
                        </div>
                      ))}
                    </div>
                  </td>
                </tr>
              ),
            )}
          </>
        )}
      </tbody>
    </table>
  );
};

export default InputInsuranceCategoryTable;
